import { Link, useNavigate } from 'react-router-dom';
import './RegisterV2.css';
import NavbarV2 from '../../components/navbarV2/NavbarV2';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RegisterV2 = () => {
    const navigate = useNavigate();

    const handleRegisterSubmit = (event) => {
        event.preventDefault();

        fetch(`${process.env.REACT_APP_API}/api/register`, {
            method: 'POST',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({
                email: event.target.email.value,
                password: event.target.password.value,
            }),
        }).then((response) => {
            if (response.status === 200) {
                toast.success('Registered successfully!');
                navigate('/login');
            } else if (response.status === 409) {
                toast.error('Account already exists.');
            } else if (response.status === 500) {
                toast.error('Server error.');
            }
        });
    };

    return (
        <div className="v2-page registerv2">
            <NavbarV2 />

            <div className="v2-container v2-container--narrow registerv2-inner">
                <div className="v2-card registerv2-card">
                    <h1 className="v2-h1 registerv2-title">Register</h1>
                    <p className="v2-muted registerv2-lead">Create an account to save details and checkout faster.</p>

                    <form onSubmit={handleRegisterSubmit}>
                        <div className="v2-field">
                            <label htmlFor="reg-email">Email</label>
                            <input type="email" name="email" id="reg-email" autoComplete="email" required />
                        </div>
                        <div className="v2-field">
                            <label htmlFor="reg-password">Password</label>
                            <input
                                type="password"
                                name="password"
                                id="reg-password"
                                autoComplete="new-password"
                                required
                            />
                        </div>
                        <div className="v2-actions registerv2-actions">
                            <button type="submit" className="v2-btn v2-btn--primary">
                                Register
                            </button>
                        </div>
                    </form>

                    <p className="v2-muted registerv2-footer">
                        Already have an account?{' '}
                        <Link to="/login" className="registerv2-inline-link">
                            Log in
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RegisterV2;
